import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import posthog from 'posthog-js';
import { patchOnboardingStateOnServer } from '../../../../utils/net/onboardingApi';
import useMapModalStore from '../../../../stores/useMapModalStore';
import ModalFrame from '../../../../ui/primitives/ModalFrame';
import {
  ONBOARDING_REWARD_EXP,
  ONBOARDING_REWARD_EXP_ICON_SRC,
  ONBOARDING_REWARD_PEARLS,
  ONBOARDING_REWARD_PEARL_ICON_SRC,
  OnboardingRewardAmountRow,
} from './onboardingRewardShared';

/** Map welcome modal (`activeModal === 'mapWelcome'`). Self-fetches queryClient/navigate/locale. */
export default function MapWelcomeHost() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const onboardingRewardNumberLocale = i18n.language?.startsWith('uk') ? 'uk-UA' : 'en-US';
  const isMapWelcomeModalOpen = useMapModalStore((s) => s.activeModal === 'mapWelcome');
  const closeModal = useMapModalStore((s) => s.closeModal);

  return (
        <ModalFrame
          isOpen={isMapWelcomeModalOpen}
          onClose={() => {}}
          hideHeader={true}
          closeOnBackdropClick={false}
          variant="dialog"
          className="max-w-[400px] px-3xl py-4xl border-2 border-brand"
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: 800, color: '#fff', fontFamily: 'Rubik One, sans-serif', lineHeight: 1.3 }}>
              {t("Welcome!")}
            </div>
            <div style={{ fontSize: 15, color: 'rgba(255,255,255,0.7)', lineHeight: 1.5 }}>
              {t("This metaverse is home to many real people, living side by side. Soon you'll become part of it too!")}
            </div>
            <div style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
              padding: '10px 16px', borderRadius: 12,
              background: 'rgba(239, 155, 3, 0.15)', border: '1px solid rgba(239, 155, 3, 0.3)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 22 }}>🎁</span>
                <span style={{ fontFamily: 'Lato, sans-serif', fontSize: 15, fontWeight: 700, color: '#FFD700' }}>
                  {t("Tutorial reward:")}
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                <OnboardingRewardAmountRow
                  iconSrc={ONBOARDING_REWARD_PEARL_ICON_SRC}
                  amount={ONBOARDING_REWARD_PEARLS}
                  numberLocale={onboardingRewardNumberLocale}
                />
                <OnboardingRewardAmountRow
                  iconSrc={ONBOARDING_REWARD_EXP_ICON_SRC}
                  amount={ONBOARDING_REWARD_EXP}
                  numberLocale={onboardingRewardNumberLocale}
                />
              </div>
            </div>
            <button
              onClick={() => {
                closeModal();
                const currentMonth = new Date().getFullYear() + "_" + String(new Date().getMonth() + 1).padStart(2, "0");
                patchOnboardingStateOnServer({ map_welcome_month: currentMonth }).catch(() => {});
                queryClient.invalidateQueries({ queryKey: ['onboarding-state'] }).catch(() => {});
                posthog.capture('onboarding_map_welcome_next_clicked');
                navigate('/tap');
              }}
              style={{
                width: '100%',
                padding: '16px 24px',
                background: 'linear-gradient(135deg, #37BFA4 0%, #02426C 100%)',
                border: 'none',
                borderRadius: 16,
                color: '#fff',
                fontSize: 17,
                fontWeight: 700,
                fontFamily: 'Rubik One, sans-serif',
                cursor: 'pointer',
              }}
            >
              {t("Start tutorial")}
            </button>
          </div>
        </ModalFrame>
  );
}
